import styles from 'js/components/data_sources/add_ds_form/SyslogConfiguration/SyslogConfiguration.module.scss';
import { ReactComponent as CopyIcon } from 'new/components/icons/copy.svg';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import React from 'react';

type Props = {
  toCopy?: string;
  title?: string;
  tooltipTitle?: string;
};

export default function CopyButton(props: Props) {
  const { toCopy, title = 'Copy', tooltipTitle = 'Click to copy' } = props;
  return (
    <ChipWithCopy
      mode="light"
      toCopy={toCopy}
      tooltipTitle={tooltipTitle}
      tooltipCopiedTitle="Copied"
    >
      <button role="button" className={styles.copyBtn}>
        <CopyIcon />
        {title}
      </button>
    </ChipWithCopy>
  );
}
